/**
 * Провайдер конфигурации приложения {@link AppConfig}, использовать при помощи хука useAppConfig()
 */

import { AppConfig } from 'application/configuration/appConfig'
import { createContext, useContext } from 'react'

const appConfigContext = createContext<AppConfig>({} as AppConfig)

export const useAppConfig = () => {
  return useContext(appConfigContext)
}

export const AppConfigProvider = appConfigContext.Provider
